const slug = require('slug')

// We always use lowercase because Netlify will force everything in the URL to lowercase anyway with a redirect.
// Using lowercase as the standard form avoids an unnecessary redirect.
module.exports = {
  createSlugForMeter: (meter) => slug(meter.replace(/\./g, '-')).toLowerCase(),
  createSlugForPerson: (person) => slug(person).toLowerCase(),
  createSlugForTuneName: (tuneName) => slug(tuneName).toLowerCase()
}
